/* Prices and links are rendered by Shopify. This element only improves scrolling. */
if (!customElements.get('macino-family-switcher')) {
  class MacinoFamilySwitcher extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.macino-family-switcher__track');
      this.controls = this.querySelector('.macino-family-switcher__controls');
      this.previous = this.querySelector('[data-family-previous]');
      this.next = this.querySelector('[data-family-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateControls();
        });
      };
      this.track.addEventListener('scroll', schedule, { passive: true, signal });
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', schedule, { passive: true, signal });
      }
      this.initialFrame = requestAnimationFrame(() => {
        this.initialFrame = null;
        const selected = this.querySelector('[aria-current="page"]');
        if (selected) {
          const trackBounds = this.track.getBoundingClientRect();
          const itemBounds = selected.getBoundingClientRect();
          const delta = itemBounds.left < trackBounds.left
            ? itemBounds.left - trackBounds.left - 3
            : Math.max(0, itemBounds.right - trackBounds.right + 3);
          if (delta) this.track.scrollBy({ left: delta, behavior: 'instant' });
        }
        this.updateControls();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.initialFrame);
      this.frame = null;
      this.initialFrame = null;
    }
    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const distance = Math.max(1, this.track.clientWidth * 0.8);
      this.track.scrollBy({
        left: direction * distance * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    updateControls() {
      const items = this.track.children;
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 2;
      this.controls.hidden = !overflowing;
      if (!overflowing || !items.length) return;
      const bounds = this.track.getBoundingClientRect();
      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.previous.disabled = rtl ? first.right <= bounds.right + 4 : first.left >= bounds.left - 4;
      this.next.disabled = rtl ? last.left >= bounds.left - 4 : last.right <= bounds.right + 4;
    }
  }
  customElements.define('macino-family-switcher', MacinoFamilySwitcher);
}
